export default __webpack_public_path__ + "static/media/video-1.5cdcef30.png";